// 顧客要望 管理No.16（ナレッジ共有）: 問い合わせ削減のため、ツール上に資料のダウンロードリンクを設置する。
// 実ファイルは public/downloads/ 配下の静的アセットとして配信し、定期リリースのタイミングで最新版へ差し替える。
// （資料の最新化がリリース後になる場合は、未配置として扱い「準備中」を表示する。）

export interface DownloadLink {
  /** 一意キー（描画 key / 将来のクリック計測用）。 */
  key: string
  /** ヘッダーに表示するラベル。 */
  label: string
  /**
   * public/downloads/ 配下の実ファイル名（= ダウンロード時の保存名）。日本語可。
   * 配信 URL は `/downloads/${encodeURIComponent(fileName)}` で組み立てる（全角・日本語を含むため）。
   * S3 キーは UTF-8 で保存されるため、percent-encoding 済みパスと一致する。
   */
  fileName: string
}

/**
 * ヘッダーに並べる資料ダウンロードリンク。
 * 実ファイルを public/downloads/ に置き、fileName をその名前に合わせるだけで更新できる。
 */
export const HEADER_DOWNLOAD_LINKS: readonly DownloadLink[] = [
  { key: 'faq', label: 'よくあるご質問', fileName: '【生活保護追加給付管理ツール】よくある質問.xlsx' },
  { key: 'manual', label: 'マニュアル', fileName: '【生活保護追加給付管理ツール】操作マニュアル.xlsx' },
] as const
